<template>
	<div class="floating-window">
		<transition name="el-zoom-in-bottom">
			<div class="list" v-show="isToggle">
				<div class="title">
					联系我们
					<i @click="isToggle=false"><em></em></i>
				</div>
				<ul>
					<li @click="onClickSample">
						<h2>样品申领<i class="animation box_Arrow2"></i></h2>
					</li>
					<li :class="{'on': conVisible}">
						<h2 @click="conVisible=!conVisible">商务合作<i class="animation box_Arrow2"></i></h2>
						<el-collapse-transition>
							<div class="con" v-show="conVisible">
								<div class="txt">
									电话: <label>{{data.phoneNumber}}</label>
									<template v-if="data.businessHours">
										<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<label>({{data.businessHours}})</label>
									</template>
									<br>
									邮箱: <a :href="`mailto:${data.email}`">{{data.email}}</a>
								</div>
							</div>
						</el-collapse-transition>
					</li>
				</ul>
			</div>
		</transition>

		<div class="btn" v-if="!isToggle" @click="isToggle=true">
			<a href="javascript:void(0);"><span>联系我们<i class="animation"></i></span></a>
		</div>
	</div>
</template>

<script>
	import {
		getAction
	} from '@/api/index';
	export default {
		name: 'LeftMenu',
		data() {
			return {
				isToggle: true,
				conVisible: true,
				url: {
					otherSetting: '/officialWebsite/c-api/setting/other'
				},
				data: {}
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			async loadData() {
				const res = await getAction(this.url.otherSetting);
				if (res.success) {
					this.data = res.result;
				}
			},
			onClickSample() {
				this.$router.push({path: '/sample'});
			}
		}
	}
</script>

<style lang="less" lang="less">
	.box_Arrow2 {
		border-top: 1px solid #7d7d7d;
		border-right: 1px solid #7d7d7d;
		width: 0.6428em;
		height: 0.6428em;
		background: #fff;
		transform: rotate(45deg);
		margin-top: -0.3217em;
		position: absolute;
	}

	.animation {
		transition: .5s all;
	}

	a,
	a:active,
	a:link,
	a:visited {
		text-decoration: none;
	}

	.floating-window {
		position: fixed;
		right: 65px;
		bottom: 50px;
		z-index: 1000;
		font-size: 14px;
		-webkit-transform: translateZ(0);

		.list {
			width: 20em;
			position: absolute;
			right: 0;
			bottom: 0;
			background: #fff;
			box-shadow: 0 0 5px rgba(0, 0, 0, .1);
			border-radius: 3px;

			.title {
				background: #314b89;
				position: relative;
				color: #fff;
				border-radius: 3px 3px 0 0;
				padding: 0 1.25em;
				line-height: 3;

				i {
					position: absolute;
					cursor: pointer;
					width: 3.5em;
					top: 0;
					right: 0;
					height: 100%;
					bottom: 0;

					em {
						position: absolute;
						width: 1em;
						left: 1.25em;
						height: 2px;
						background: #fff;
						top: 50%;
						margin-top: -1px;
					}
				}
			}

			h2 {
				font-size: 100%;
				font-weight: 400;
				padding: 0 1.25em;
				cursor: pointer;
				position: relative;
				line-height: 3;
				background: #f9f9f9;
				color: #2b2b2b;

				i {
					background: #f9f9f9;
					top: 50%;
					right: 1.25em;
				}
			}

			ul {
				li {
					list-style-type: none;
				}

				li:hover h2 {
					color: #314b89;
					background: #fff;
				}

				li.on {
					h2 {
						color: #314b89;
						background: #fff;
					}

					h2 i {
						background: #fff;
						border-color: #314b89;
						transform: rotate(135deg);
					}
				}
			}

			.con {
				color: #7d7d7d;
				line-height: 2;
				display: block;
				padding: 0 1.25em;
				padding-bottom: 1.25em;

				.txt {
					font-size: 12px;
				}

				label,
				a {
					color: #314b89;
				}

				a:hover {
					text-decoration: underline;
				}
			}
		}

		.btn {
			position: absolute;
			right: 0;
			bottom: 0;
			font-size: 13px;

			a {
				background: #314b89;
				width: 10.4285em;
				color: #fff;
				display: inline-block;
				border-radius: 1.4285em;
				padding: 0 1.5714em 0 2.4285em;

				span {
					display: inline-block;
					padding-right: 1.5714em;
					position: relative;
					line-height: 2.7857;

					i {
						display: inline-block;
						position: absolute;
						width: 15px;
						height: 10px;
						margin-top: -5px;
						right: 0;
						top: 50%;
						background: url('~@/assets/png/jt04.png') no-repeat right center;
					}
				}
			}
		}
	}
</style>